function Spirituality() {
  return (
    <div style={{ padding: '60px', textAlign: 'center' }}>
      <h1>Spirituality</h1>
      <p>Deep dive into spiritual wisdom and healing practices.</p>
    </div>
  );
}

export default Spirituality;
